import { SET_APP_CONFIGS, SetAppConfigsAction } from '../types'
import { LiabilityMapping } from './types'

const initialState: LiabilityMapping = {}

const LiabilityMappingReducer = (state = initialState, action: SetAppConfigsAction) => {
  switch (action.type) {
    case SET_APP_CONFIGS:
      return action.payload.liabilityMapping
    default:
      return state
  }
}

export default LiabilityMappingReducer
